import { BaseObject, MongoObject } from './_baseClasses';
import * as utils from './utils'
import { User } from './User'
import { Story, statusType, privacyType } from './Story'
import { StoryUser } from './StoryUser'
import { userInfo } from 'os';

const DEBUGGING: boolean = false

export type circlePlanTypes = 'free'|'paid'

export class Circle extends MongoObject {
  protected static collectionName: string = 'circles'    // IMPORTANT

  // fields
  public storyTellerId: string = null   // the subject
  public plan: circlePlanTypes = null

  public managers: string[] = []        // TODO
  public followedBy: string[] = []
  public pendingIncomingFollowers: string[] = []
  public deleted: boolean = null

  // maybe
  public blocked: string[] = []                       // means these folks cannot ask to join this circle

  // complex, class-based fields (require to be hydrated after loading from external sources like mongo or elastic)

  constructor(po?: object, storyTellerId?: string) {
    super()
    if (po) this.injectPlainObject(po)
    if (storyTellerId != null) this.storyTellerId = storyTellerId
    this.hydrate()
  }

  // on both client and server side
  public getTraitObjectForSegment(): any {
    return {
      storyTellerId: this.storyTellerId,
      numManagers: this.managers.length,
      numFollowers: this.followedBy.length,
      pendingIncomingFollowers: this.pendingIncomingFollowers.length,
      createdAt: this.created.toISOString(),
      plan: this.plan
    }
  }

  public isFollowedBy(userId: string): boolean {
    return this.followedBy.includes(userId)
  }
  public isPendingIncomingFollower(userId: string): boolean {
    return this.pendingIncomingFollowers.includes(userId)
  }
  public isManagedBy(userId: string): boolean {
    return this.managers.includes(userId)
  }

  public hasReadAccess(userId: string): boolean {
    return userId === this.storyTellerId || this.isFollowedBy(userId)
  }

  public canAskMeAQuestion(userId: string): boolean {
    return userId === this.storyTellerId || this.isFollowedBy(userId)
  }

  public canManage(userId: string): boolean {
    return userId === this.storyTellerId || this.isManagedBy(userId)
  }

  public async changeCirclePlan(user: StoryUser, plan: circlePlanTypes): Promise<void> {
    this.plan = plan

    // PUT it to the server
    const url: string = utils.getURLprefix() + `/api/circles/${this.getIdAsString()}/changePlan`;
    try {
      const response: any = await utils.makePutCall(url, { plan });

      let circle: Circle = response.data.circle;
      if (circle && user.getIdAsString() === circle.storyTellerId) {
        circle = new Circle(circle);
        user._temp.circle = circle
        user.updateMeToCacheStoreAndLocalStorage()
      }
    } catch (error) {
      console.log(`Circle.changeCirclePlan() got ${error}`)
    }
  }
}
